import React from 'react'

export const Loading = () => <h1>Данные загружаются...</h1>

